export const staticHeroHeaderTheme = () => {
  const hero = document.querySelector("#home");
  if (!hero) return;

  if (document.getElementById("homeHeroSlider")) return;

  const heroVideo = hero.querySelector(".hero__video video");
  if (heroVideo && !hero.querySelector(".hero__image")) {
    const applyRatio = () => {
      if (!heroVideo.videoWidth || !heroVideo.videoHeight) return;
      hero.style.setProperty(
        "--hero-video-ratio",
        `${heroVideo.videoWidth} / ${heroVideo.videoHeight}`
      );
    };
    applyRatio();
    heroVideo.addEventListener("loadedmetadata", applyRatio);
  }

  const elements = [
    document.querySelector(".navbar__logo"),
    document.querySelector(".navbar"),
    document.querySelector("#toggleMenu"),
    document.querySelector("#toggleMenu .burger"),
  ];
  const header = document.querySelector("#header");

  const applyTheme = (isHeroInView) => {
    elements.forEach((el) => {
      if (!el) return;
      el.classList.toggle("isLight", isHeroInView);
      el.classList.toggle("isDark", !isHeroInView);
    });
    header?.classList.toggle("isWhite", !isHeroInView);
  };

  applyTheme(true);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => applyTheme(entry.isIntersecting));
    },
    { threshold: 0.5 }
  );
  observer.observe(hero);
};

export const bestsellersParallaxHeading = () => {
  const section = document.getElementById("bestsellers");
  const text = section?.querySelector("[data-bestsellers-parallax]");
  if (!section || !text) return;

  const maxShift = 200;
  let isInView = false;
  let ticking = false;

  const update = () => {
    ticking = false;
    if (!isInView) return;

    const rect = section.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    // progress goes 0 -> 1 as the section travels from just below the
    // viewport to just above it, so the shift is centered while it's on screen.
    const progress = 1 - (rect.top + rect.height / 2) / (viewportH + rect.height);
    const clamped = Math.min(Math.max(progress, 0), 1);
    const shift = (clamped - 0.5) * 2 * maxShift;
    text.style.transform = `translateX(${shift}px)`;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isInView = entry.isIntersecting;
        if (isInView) onScroll();
      });
    },
    { threshold: 0, rootMargin: "20% 0px" }
  );
  observer.observe(section);

  window.addEventListener("scroll", onScroll, { passive: true });
};

export const hideNavOnFooter = () => {
  const homeNavEl = document.querySelector("#homeNav");
  const footer = document.querySelector("#footer");
  if (!homeNavEl || !footer) return;

  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        homeNavEl.classList.toggle("isHidden", entry.isIntersecting);
      });
    },
    { threshold: 0, rootMargin: "0px 0px -95% 0px" }
  );
  footerObserver.observe(footer);
};

export const homeNav = () => {
  const navEl = document.querySelector("#homeNav");
  const sections = document.querySelectorAll("section");
  const navLinks = document.querySelectorAll(".home-nav a");
  if (!navEl) return;
  const movePill = () => {
    const active = navEl.querySelector("a.isActive");
    navEl.style.setProperty("--pill-x", `${active ? active.offsetLeft : 0}px`);
    navEl.style.setProperty("--pill-w", `${active ? active.offsetWidth : 0}px`);
  };

  const setActive = (sectionId) => {
    let changed = false;
    navLinks.forEach((link) => {
      const isActive = link.getAttribute("data-active-link") === sectionId;
      if (link.classList.contains("isActive") !== isActive) {
        link.classList.toggle("isActive", isActive);
        changed = true;
      }
    });
    if (changed) movePill();
  };

  let scrollTarget = null;
  let scrollTargetTimer = null;
  const releaseScrollTarget = () => {
    scrollTarget = null;
    clearTimeout(scrollTargetTimer);
    updateActiveLink();
  };

  function updateActiveLink() {
    if (scrollTarget) return;
    let currentSection = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
        currentSection = section.getAttribute("id");
      }
    });

    setActive(currentSection);
  }

  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  });
  window.addEventListener("scrollend", () => {
    if (scrollTarget) releaseScrollTarget();
  });
  window.addEventListener("resize", movePill);

  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const sectionId = this.getAttribute("data-active-link");
      const section = document.getElementById(sectionId);

      if (section) {
        scrollTarget = sectionId;
        clearTimeout(scrollTargetTimer);
        // Fallback for browsers without the scrollend event.
        scrollTargetTimer = setTimeout(releaseScrollTarget, 1200);
        setActive(sectionId);
        section.scrollIntoView({ behavior: "smooth" });
      }
    });
  });

  // First position without animation, then enable the transition.
  updateActiveLink();
  movePill();
  requestAnimationFrame(() => navEl.classList.add("hasPill"));
  document.fonts?.ready.then(movePill);
};
